<svg [ngClass]="class" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z" fill="#D1C8BA"/>
  <g clip-path="url(#clip0_17212_183120)">
    <path d="M20.1719 7.625C21.4051 7.62505 22.5708 8.11661 23.4326 9.04004L23.4512 9.05859C25.3142 10.922 25.3144 13.8975 23.4512 15.7607L23.4482 15.7627L15.499 23.7773L7.55078 15.7627L7.54883 15.7607L7.37988 15.582C5.6877 13.7117 5.74383 10.8637 7.54883 9.05859L7.62109 8.98633C9.35517 7.25256 12.195 7.19808 13.999 8.88086L14.1699 9.0498L14.1787 9.05859L14.9697 9.84863L15.5 10.3799L16.0303 9.84863L16.8926 8.98633C17.7598 8.11919 18.9356 7.625 20.1719 7.625Z" fill="#B79086" stroke="#372121" stroke-width="1.5"/>
  </g>
  <defs>
    <clipPath id="clip0_17212_183120">
      <rect width="23" height="23" fill="white" transform="translate(4 4)"/>
    </clipPath>
  </defs>
</svg>
